// Services
import ValidacaoDetalheService from "./ValidacaoDetalheService";

export default {
  mixins: [ValidacaoDetalheService],
  data() {
    return {
      mostrarModalAprovar: false,
      mostrarModalReprovar: false,
      idAtual: -1,
      objetoInformacoes: {},
      loadingInformacoes: false,
      codigoUnimed: -1,
      checkboxErros: [],
      quantidadeTotal: 0,
      mapValoresCheck: null,
      possuiAlgumErroConsiderado: false,
      habilitarBotoesRealizarAnalise: false,
      habilitarBotaoAssumirAnalise: false,
      habilitarBotaoDesconsiderarErros: false
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    desconsiderarErros() {
      const tituloModalConfirmar =
        this.checkboxErros.length > 1
          ? "Desconsiderar erros?"
          : "Desconsiderar erro?";
      const mensagemModalConfirmar =
        this.checkboxErros.length > 1
          ? "Ao desconsiderar esses erros, eles não serão enviados."
          : "Ao desconsiderar esse erro, ele não será enviado.";

      this.$store.dispatch("setMostrarModalConfirmarResumido", {
        mostrarModalConfirmar: true,
        callbackModalConfirmar: () => this.confirmarDesconsiderarErros(),
        tituloModalConfirmar,
        mensagemModalConfirmar,
        textoBotaoModalConfirmar: "SIM, DESCONSIDERAR",
        tipoBotaoModalConfirmar: "importante",
        larguraBotaoModalConfirmar: 211,
        larguraModalConfirmar: 540
      });
    },
    confirmarDesconsiderarErros() {
      this.$store.commit("setMostrarModalConfirmar", false);

      let arrayVerdadeiro = [],
        arrayFalso = [];

      this.checkboxErros.forEach(valor => {
        if (this.mapValoresCheck.get(valor)) {
          arrayVerdadeiro.push(valor);
        } else {
          arrayFalso.push(valor);
        }
      });

      let objetoVerdadeiro = {
          desconsiderar: true,
          idArquivo: this.idAtual,
          ids: arrayFalso
        },
        objetoFalso = {
          desconsiderar: false,
          idArquivo: this.idAtual,
          ids: arrayVerdadeiro
        };

      this.$store.commit("setLoadingModal", true);
      this.postDesconsiderar(objetoFalso)
        .then(() => {
          this.postDesconsiderar(objetoVerdadeiro).finally(() => {
            this.$store.commit("setLoadingModal", false);
            this.$store.commit(
              "setSubtituloSucesso",
              `Os itens apontados foram desconsiderados e/ou considerados.`
            );
            this.$store.commit("setMostrarSucessoModal", true);
            this.$store.commit("setCallbackFecharSucesso", () => {
              this.reiniciarComponentes();
            });
          });
        })
        .catch(() => {
          this.$store.commit("setLoadingModal", false);
          this.reiniciarComponentes();
        });
    },

    reiniciarComponentes() {
      this.$refs.tabelaErro.limparCheck();
      this.$refs.tabelaErro.iniciarTabela();
      this.recuperarArquivoAtual();
    },

    /**
     * Método inicial
     */
    init() {
      this.recuperarIdUrl().then(() => {
        if (this.idAtual === -1) return;
        this.recuperarArquivoAtual().then(() => {
          this.inicializarVariaveis();
          this.inicializarObservacoes();
        });
      });
    },
    /**
     * Método para recuperar o id que está na url, contém algumas verificações para saber se o id é válido
     */
    recuperarIdUrl() {
      return new Promise((resolve, reject) => {
        const { id } = this.$route.params;
        if ([null, undefined, "", -1].includes(id)) {
          this.$store.commit("criarErroGenerico", {
            mostrarErro: true,
            codigoErro: 400,
            mensagemErro: "ID do arquivo inválido."
          });
          return reject();
        }
        this.idAtual = id;
        resolve();
      });
    },
    /**
     * Método que faz a chamada na service para recuperar dados para o componente CardInformações
     */
    recuperarArquivoAtual() {
      return new Promise((resolve, reject) => {
        this.loadingInformacoes = true;

        this.getValidacaoById(this.idAtual)
          .then(res => {
            const {
              dataEnvio,
              nomeArquivo,
              numeroProtocolo,
              status,
              unimedOrigem,
              versaoPtu,
              cdUnimedOrigem,
              possuiAlgumErroConsiderado,
              usuarioAlteracao
            } = res.data;

            this.habilitarBotaoAssumirAnalise = usuarioAlteracao === null;
            this.habilitarBotoesRealizarAnalise = usuarioAlteracao
              ? this.isUsuarioAssumiuAnalise(usuarioAlteracao)
              : false;
            this.codigoUnimed = parseInt(cdUnimedOrigem);

            this.objetoInformacoes = {
              nomeUnimed: unimedOrigem,
              dataEnvio: dataEnvio
                ? this.$helpers.formatadorHorario(dataEnvio)
                : "",
              status: status.chave,
              nomeArquivo,
              numeroProtocolo,
              versao: versaoPtu
            };

            this.possuiAlgumErroConsiderado = possuiAlgumErroConsiderado;
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.loadingInformacoes = false;
          });
      });
    },
    /**
     * Método que é chamado logo após a modal de aprovação for confirmada
     */
    confirmarAprovar() {
      this.mostrarModalAprovar = false;
      this.$store.commit("setLoadingModal", true);
      this.postAprovar(this.idAtual)
        .then(() => {
          const { nomeArquivo } = this.objetoInformacoes;
          this.$store.commit(
            "setSubtituloSucesso",
            `O arquivo ${nomeArquivo} foi aprovado`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.recuperarArquivoAtual();
            this.$refs.tabelaErro.iniciarTabela();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    /**
     * Método que é chamado logo após a modal de reprovação for confirmada
     */
    confirmarReprovar() {
      this.mostrarModalReprovar = false;
      this.$store.commit("setLoadingModal", true);
      this.postReprovar(this.idAtual)
        .then(() => {
          const { nomeArquivo } = this.objetoInformacoes;
          this.$store.commit(
            "setSubtituloSucesso",
            `O arquivo ${nomeArquivo} foi reprovado`
          );
          this.$store.commit("setMostrarSucessoModal", true);
          this.$store.commit("setCallbackFecharSucesso", () => {
            this.recuperarArquivoAtual();
            this.$refs.tabelaErro.iniciarTabela();
          });
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },
    /**
     * Método que baixa o relatório de erros
     */
    exportarRelatorio() {
      this.$store.commit("setLoadingModal", true);
      this.getRelatorioDownload(this.idAtual)
        .then(res => {
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    },

    /**
     * Método inicializador de observações
     * @return {Promise<null>}
     */
    inicializarObservacoes() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("inicializarObservacaoStore")
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    inicializarVariaveis() {
      this.$store.commit("setCodigoUnimedObservacao", this.codigoUnimed);
    },

    abrirObservacoes() {
      this.mostrarMenuObservacao = true;
    },

    /**
     * Método que é chamado logo após clicar no botão "Assumir Análise"
     */
    assumirAnalise() {
      this.postAssumirAnalise(this.idAtual).then(() => {
        this.recuperarArquivoAtual();
      });
    },

    isUsuarioAssumiuAnalise(usuarioResponsavelAnalise) {
      const cpfUsuarioLogado = this.$store.getters.getObjetoUsuario.cpf.replace(
        /\D/g,
        ""
      );
      return cpfUsuarioLogado === usuarioResponsavelAnalise.login;
    }
  },

  computed: {
    mostrarBotaoReprovar() {
      return this.possuiAlgumErroConsiderado;
    }
  }
};
